<template>
    <div class="notification-edit-container">
        <NotificationForm
            title="Edit Notification Post"
            @cancel="cancel"
            @post="post"
        ></NotificationForm>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import * as notificationModule from '@/store/notification'
import NotificationForm from '@/components/notification/NotificationForm.vue'

export default {
	props: ['notificationId'],

	async beforeRouteLeave (to, from, next) {
		const hasChanges = await this.$store.dispatch('notification/hasChanges')

		if (hasChanges) {
			// this.$store.commit('toggleModal', {
			// 	modalName: 'not-empty-form',
			// 	confirm: () => {
			// 		this.$store.dispatch('modal/closeModal')
			// 		this.$store.dispatch('notification/clearData')
			// 		next()
			// 	}
			// })

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Your input will be lost.',
                action: () => {
					this.$store.dispatch('modal/closeModal')
					this.$store.dispatch('notification/clearData')
					next()
				}
            })
            
			return
		}

		this.$store.dispatch('notification/clearData')
		next()
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['notification/']) {
			this.$store.registerModule('notification', notificationModule.default)
		}
	},

	computed: {
		...mapFields('notification', {
			oldNotification: 'oldNotification',
			userFilter: 'userFilter'
		})
	},

	async created () {
		// await this.$store.dispatch('notification/getCountryList')
		await this.$store.dispatch('notification/edit', this.notificationId)
	},

	methods: {
		cancel () {
			this.$router.push({ name: 'notification-post' })
		},

		async post (form) {
			form.append('id', this.notificationId)
			let res = await this.$store.dispatch('notification/update', { form })

            if (res) {
                this.$store.dispatch('toggleBanner', {
                    status: true,
                    message: 'Notification is successfully updated.',
                    type: 'success'
                })
    
                this.$router.push({ name: 'notification-post' })
            }

		}
	},

	components: {
		NotificationForm
	}
}
</script>

<style lang="scss" scoped>
.notification-edit-container {
	padding-left: calc(100px - 1em);
	padding-top: 2em;
	padding-bottom: 2em;
	width: 100%;
	height: 100%;
	overflow: auto;
}
</style>
